let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("76u5F")).then(() => parcelRequire('77Eyd'));